import { useNavigatePage } from "../../hooks/useNavigatePage";
import { useMemberStore } from "../../store/memberStore";
import { BtnBox } from "../../style/common";
import Btn from "../common/Btn";
import GoBackBtn from "../common/GoBackBtn";

interface ContentBtnsProps {
  onClick: () => void;
  idx?: string;
}

export default function ContentBtns({ onClick, idx }: ContentBtnsProps) {
  const { onMovementPage } = useNavigatePage()
  const { memberPermitLevel } = useMemberStore();

  return (
    <BtnBox>
      {memberPermitLevel >= 100 && (
        <>
          {idx && <Btn type="button" title="수정" color="blue" onClick={() => onMovementPage(`/notice/detail/${idx}/add`)} />}
          <Btn type="button" title="삭제" color="red" onClick={onClick} />
        </>
      )}
      <GoBackBtn />
    </BtnBox>
  );
}